module.exports = __webpack_public_path__ + "img/balance-scale.94bb3856.svg";